/**
 * LoadingSpinner
 *
 * Props:
 *   text      – spinner altındaki yazı (default: 'Yükleniyor...')
 *               null/false geçilirse yazı gösterilmez
 *   size      – 'sm' | 'md' | 'lg'  (default: 'md')
 *   color     – 'indigo' | 'violet' | 'cyan' | 'slate' | 'rose' | 'blue'  (default: 'indigo')
 *   fullPage  – true → py-24 ortalanmış wrapper (default: false)
 *   className – ek class'lar wrapper div'e eklenir
 *
 * Kullanım örnekleri:
 *   <LoadingSpinner />
 *   <LoadingSpinner size="lg" text="Veriler yükleniyor..." />
 *   <LoadingSpinner fullPage text="Rezervasyonlar okunuyor..." />
 *   <LoadingSpinner color="violet" />
 *   <LoadingSpinner text={null} />   ← sadece spinner, yazısız
 */

const SIZES = {
  sm: 'w-8  h-8  border-[3px]',
  md: 'w-10 h-10 border-[3px]',
  lg: 'w-16 h-16 border-4',
};

const COLORS = {
  indigo: 'border-indigo-100 border-t-indigo-500',
  violet: 'border-violet-100 border-t-violet-500',
  cyan:   'border-cyan-100   border-t-cyan-500',
  slate:  'border-slate-100  border-t-slate-500',
  rose:   'border-rose-100   border-t-rose-500',
  blue:   'border-blue-100   border-t-blue-500',
};

export default function LoadingSpinner({
  text = 'Yükleniyor...',
  size = 'md',
  color = 'indigo',
  fullPage = false,
  className = '',
}) {
  const spinnerClass = `${SIZES[size] ?? SIZES.md} ${COLORS[color] ?? COLORS.indigo} rounded-full animate-spin`;

  const inner = (
    <>
      <div className={spinnerClass} />
      {text && (
        <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
          {text}
        </p>
      )}
    </>
  );

  if (fullPage) {
    return (
      <div className={`py-24 flex flex-col items-center justify-center gap-4 ${className}`}>
        {inner}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      {inner}
    </div>
  );
}
